import React, { useRef, useState } from 'react';
import { AdmissionRequirementBox } from './GSB1FormBox';
import {
  useGetPreCheck,
  useCreatePreCheck,
  type AdmissionRequirementValue,
  useGetApplicationStudyMode,
} from '../../../graphql/NominationForm';
import { Loading, Alert, type AlertDetails } from '../../../../../components';

export const AdmissionRequirement: React.FunctionComponent<{
  applicationId: string;
  admission: AdmissionRequirementValue;
  isViewMode?: boolean;
  refetchAdmission: () => void;
}> = props => {
  const {
    applicationId,
    admission,
    isViewMode = false,
    refetchAdmission,
  } = props;
  const [openAlert, setOpenAlert] = useState(false);
  const [alertDetails, setAlertDetails] = useState<AlertDetails>({
    alertContent: '',
    alertType: 'error',
  });

  const {
    isFullTime,
    isPhd,
    loading: studyModeLoading,
    error: studyModeError,
  } = useGetApplicationStudyMode(applicationId ?? '');

  const {
    preliminaryCheck,
    loading: preCheckLoading,
    error: preCheckError,
    refetch: refetchPreCheck,
  } = useGetPreCheck(applicationId);

  const createPreCheck = useCreatePreCheck();
  const handleCreateCalled = useRef(false); // to trace if handleCreatePreliminaryCheck has been executed

  const handleCreatePreliminaryCheck = async (): Promise<void> => {
    try {
      const variables = {
        applicationId,
      };
      await createPreCheck({
        variables,
      });
      refetchPreCheck();
    } catch (error: any) {
      setAlertDetails({
        alertContent: `Error Occurs.` + (error as Error).message,
        alertType: 'error',
      });
      setOpenAlert(true);
    }
  };

  if (
    !preCheckLoading &&
    preliminaryCheck.rules.length === 0 &&
    !handleCreateCalled.current
  ) {
    handleCreateCalled.current = true;
    void handleCreatePreliminaryCheck();
  }

  if (preCheckError ?? studyModeError) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent:
            `Error Occurs.` +
            (preCheckError as Error)?.message +
            (studyModeError as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  const loading =
    preCheckLoading || !preliminaryCheck.rules.length || studyModeLoading;

  return (
    <>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />
      {loading ? (
        <Loading />
      ) : (
        <AdmissionRequirementBox
          preliminaryCheck={preliminaryCheck}
          admission={admission}
          isFullTime={isFullTime}
          isViewMode={isViewMode}
          isPhd={isPhd}
          refetchAdmission={refetchAdmission}
        />
      )}
    </>
  );
};
